import React from 'react';
import { Route } from 'react-router-dom';

import { ClientsReportProvider } from '@seller-area/contexts/clients-report';
import { GruposReportProvider } from '@seller-area/contexts/grupos-report';
import { UnitsConsumidorasProvider } from '@seller-area/contexts/units-consumidoras';
import {
  CLIENT_XRAY_PATH,
  COMPANY_DETAILS_PATH,
  CREATE_CUSTOMER_PATH,
  CREATE_GROUP_PATH,
  CREATE_UNIT_PATH,
  EDIT_CUSTOMER_PATH,
  EDIT_GROUP_PATH,
  EDIT_UNIT_PATH,
  GROUP_DETAILS_PATH,
  GRUPOS_LIST_PATH,
  HOME_PATH,
  UNITS_CONSUMIDORAS_CREATE_UNIT_PATH,
  UNITS_CONSUMIDORAS_PATH,
  UNIT_XRAY_PATH,
  UNIT_XRAY_STANDALONE_PATH,
} from '@seller-area/routers/constants';

const GruposListPage = React.lazy(() => import('@seller-area/pages/grupos'));
const CustomersReportListPage = React.lazy(
  () => import('@seller-area/pages/customer-panel/customers-report-list-page'),
);
const UnitsConsumidorasPage = React.lazy(() => import('@seller-area/pages/units-consumidoras'));
const CreateGroupPage = React.lazy(() => import('@seller-area/pages/grupos/grupos-create'));
const EditGroupPage = React.lazy(() => import('@seller-area/pages/grupos/grupos-edit'));
const CustomerFormPage = React.lazy(() => import('@seller-area/pages/customer-panel/customer-form'));
const UnitFormPage = React.lazy(() => import('@seller-area/pages/customer-panel/customer-details/create-unit'));
const CustomerDetailsPage = React.lazy(() => import('@seller-area/pages/customer-panel/customer-details'));
const UnitXRayPage = React.lazy(() => import('@seller-area/pages/unit-xray'));
const ClientXRayPage = React.lazy(() => import('@seller-area/pages/client-xray'));

export const customerBaseRoutes = (): JSX.Element[] => [
  <Route
    key={GRUPOS_LIST_PATH}
    path={GRUPOS_LIST_PATH}
    element={
      <GruposReportProvider>
        <GruposListPage />
      </GruposReportProvider>
    }
  />,
  <Route
    key={HOME_PATH}
    path={HOME_PATH}
    element={
      <ClientsReportProvider>
        <CustomersReportListPage />
      </ClientsReportProvider>
    }
  />,
  <Route
    key={UNITS_CONSUMIDORAS_PATH}
    path={UNITS_CONSUMIDORAS_PATH}
    element={
      <UnitsConsumidorasProvider>
        <UnitsConsumidorasPage />
      </UnitsConsumidorasProvider>
    }
  />,
  <Route key={CREATE_GROUP_PATH} path={CREATE_GROUP_PATH} element={<CreateGroupPage />} />,
  <Route key={EDIT_GROUP_PATH} path={EDIT_GROUP_PATH} element={<EditGroupPage />} />,
  <Route key={CREATE_CUSTOMER_PATH} path={CREATE_CUSTOMER_PATH} element={<CustomerFormPage />} />,
  <Route key={EDIT_CUSTOMER_PATH} path={EDIT_CUSTOMER_PATH} element={<CustomerFormPage />} />,
  <Route
    key={UNITS_CONSUMIDORAS_CREATE_UNIT_PATH}
    path={UNITS_CONSUMIDORAS_CREATE_UNIT_PATH}
    element={<UnitFormPage />}
  />,
  <Route
    key={COMPANY_DETAILS_PATH + CREATE_UNIT_PATH}
    path={COMPANY_DETAILS_PATH + CREATE_UNIT_PATH}
    element={<UnitFormPage />}
  />,
  <Route
    key={COMPANY_DETAILS_PATH + EDIT_UNIT_PATH}
    path={COMPANY_DETAILS_PATH + EDIT_UNIT_PATH}
    element={<UnitFormPage mode="edit" />}
  />,
  <Route
    key={COMPANY_DETAILS_PATH + UNIT_XRAY_PATH}
    path={COMPANY_DETAILS_PATH + UNIT_XRAY_PATH}
    element={<UnitXRayPage />}
  />,
  <Route key={UNIT_XRAY_STANDALONE_PATH} path={UNIT_XRAY_STANDALONE_PATH} element={<UnitXRayPage />} />,
  <Route key={CLIENT_XRAY_PATH} path={CLIENT_XRAY_PATH} element={<ClientXRayPage />} />,
  <Route key={GROUP_DETAILS_PATH} path={GROUP_DETAILS_PATH} element={<CustomerDetailsPage scope="client" />} />,
  <Route key={COMPANY_DETAILS_PATH} path={COMPANY_DETAILS_PATH} element={<CustomerDetailsPage scope="company" />} />,
];
